import styled, { keyframes } from 'styled-components';
import { BREAKPOINTS } from '../../spacing/index.js';
import { rem } from '../../utils/functions.js';
import { typography } from '../../typography/typography.js';

var ProgressWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__ProgressWrapper",
  componentId: "yuzvl8-0"
})(["", " display:flex;height:", ";width:", ";pointer-events:none;", ""], function (_ref) {
  var isFloating = _ref.isFloating;
  return isFloating ? "\n        position: absolute;\n        z-index: 999;\n        margin: auto;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        align-items: center;\n        justify-content: center;\n      " : "\n        position: relative;\n      ";
}, function (_ref2) {
  var diameter = _ref2.diameter,
      isFixedSize = _ref2.isFixedSize;
  return isFixedSize ? '' : "".concat(diameter, "px");
}, function (_ref3) {
  var diameter = _ref3.diameter,
      isFixedSize = _ref3.isFixedSize;
  return isFixedSize ? '' : "".concat(diameter, "px");
}, function (_ref4) {
  var spinnerStyle = _ref4.spinnerStyle;
  return spinnerStyle;
});
process.env.NODE_ENV !== "production" ? ProgressWrapper.displayName = 'ProgressWrapper' : void 0;
var SubWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__SubWrapper",
  componentId: "yuzvl8-1"
})(["align-items:center;display:flex;flex-direction:column;font-family:", ";font-size:", ";font-weight:600;line-height:", ";letter-spacing:", ";color:", ";"], typography.fontFamily, typography.fontSize, typography.lineHeight, typography.letterSpacing, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
});
process.env.NODE_ENV !== "production" ? SubWrapper.displayName = 'SubWrapper' : void 0; // Styled components for Circle

var circleFadeDelay = /*#__PURE__*/keyframes(["0%,39%,100%{opacity:0;}40%{opacity:1;}"]);
var CirclePrimitive = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__CirclePrimitive",
  componentId: "yuzvl8-2"
})(["width:100%;height:100%;position:absolute;left:0;top:0;", " &:before{content:'';display:block;margin:0 auto;width:15%;height:15%;background-color:", ";border-radius:100%;animation:", " 1.2s infinite ease-in-out both;", "}"], function (_ref6) {
  var rotate = _ref6.rotate;
  return rotate && "\n      -webkit-transform: rotate(".concat(rotate, "deg);\n      -ms-transform: rotate(").concat(rotate, "deg);\n      transform: rotate($").concat(rotate, "deg);\n    ");
}, function (_ref7) {
  var color = _ref7.color;
  return color;
}, circleFadeDelay, function (_ref8) {
  var delay = _ref8.delay;
  return delay && "\n        -webkit-animation-delay: ".concat(delay, "s;\n        animation-delay: ").concat(delay, "s;\n      ");
});
process.env.NODE_ENV !== "production" ? CirclePrimitive.displayName = 'CirclePrimitive' : void 0; // Styled components for CircularIndeterminate

/* Inspired by: https://medium.com/eedi/animating-svg-with-styled-components-34284a7429a3 */

var StyledSpinner = /*#__PURE__*/styled.svg.withConfig({
  displayName: "styledComponents__StyledSpinner",
  componentId: "yuzvl8-3"
})(["height:100%;width:100%;animation:rotate 2s linear infinite;& .path{stroke:", ";stroke-linecap:round;animation:dash 1.5s ease-in-out infinite;}@keyframes rotate{100%{transform:rotate(360deg);}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0;}50%{stroke-dasharray:90,150;stroke-dashoffset:-35;}100%{stroke-dasharray:90,150;stroke-dashoffset:-124;}}"], function (_ref9) {
  var color = _ref9.color;
  return color;
});
process.env.NODE_ENV !== "production" ? StyledSpinner.displayName = 'StyledSpinner' : void 0;
var Loader = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Loader",
  componentId: "yuzvl8-4"
})(["display:flex;"]);
process.env.NODE_ENV !== "production" ? Loader.displayName = 'Loader' : void 0;
var LoaderElement = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__LoaderElement",
  componentId: "yuzvl8-5"
})(["background-repeat:no-repeat;background-size:contain;height:65px;margin:calc(4px * 1.2);width:12px;&:nth-child(1){animation:preloader 0.9s ease-in-out alternate 0.2s infinite;}&:nth-child(2){animation:preloader 0.9s ease-in-out alternate 0.4s infinite;}&:nth-child(3){animation:preloader 0.9s ease-in-out alternate 0.6s infinite;}@keyframes preloader{100%{transform:scale(1.2);}}@media (max-width:", "px){margin:calc(2.5px * 1.2);height:43px;width:8px;}"], BREAKPOINTS.MAX_768);
process.env.NODE_ENV !== "production" ? LoaderElement.displayName = 'LoaderElement' : void 0;
var LoaderMessage = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__LoaderMessage",
  componentId: "yuzvl8-6"
})(["text-align:center;font-size:", ";line-height:", ";margin-top:16px;@media (max-width:", "px){font-size:", ";line-height:", ";margin-top:8px;}", ""], rem(20), rem(28), BREAKPOINTS.MAX_768, typography.fontSize, typography.lineHeight, function (_ref10) {
  var messageStyle = _ref10.messageStyle;
  return messageStyle;
});
process.env.NODE_ENV !== "production" ? LoaderMessage.displayName = 'LoaderMessage' : void 0;

export { CirclePrimitive, Loader, LoaderElement, LoaderMessage, ProgressWrapper, StyledSpinner, SubWrapper };
